import { createContext, Dispatch, SetStateAction } from 'react';
import { CachedTenderShareDetails } from '~components/atoms/CachedSharesTable/ProjectWebCachedSharesTable';
import { StoredSharedTender } from '~components/atoms/FileTables/SharedTenderAttachmentsTable';

export interface CachedShareCtx {
  currentCachedShare: CachedTenderShareDetails | null;
  setCurrentCachedShare: Dispatch<
    SetStateAction<CachedShareCtx['currentCachedShare']>
  >;
  cachedSharesContext: StoredSharedTender[];
  setCachedSharesContext: Dispatch<
    SetStateAction<CachedShareCtx['cachedSharesContext']>
  >;
}

const CachedSharesContext = createContext({
  currentCachedShare: {},
  setCurrentCachedShare: () => ({}),
  cachedSharesContext: [],
  setCachedSharesContext: () => [],
} as CachedShareCtx);

export default CachedSharesContext;
